var exports = {
  "uW": "x7be19a29--778f74--section",
  "kL": "x7be19a29--778f74--container",
  "p_": "x7be19a29--778f74--list",
  "Nr": "x7be19a29--778f74--card",
  "jW": "x7be19a29--778f74--photo",
  "Qq": "x7be19a29--778f74--text",
  "R_": "x7be19a29--778f74--heading",
  "zg": "x7be19a29--778f74--class",
  "CR": "x7be19a29--778f74--metro",
  "WB": "x7be19a29--778f74--metro-name",
  "M3": "x7be19a29--778f74--metro-icon",
  "wz": "x7be19a29--778f74--representative",
};

module.exports = exports;
